module.exports = __webpack_public_path__ + "static/img/Vehicle PU products application horizontal_desktop.8a4a2616.jpg";